import { render, staticRenderFns } from "./PageTeachingReview.vue?vue&type=template&id=2aad5424&"
import script from "./PageTeachingReview.vue?vue&type=script&lang=js&"
export * from "./PageTeachingReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports